import React from 'react';

const DataGapsSection = () => {
  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h2 className="text-3xl font-bold text-gray-900">Data Gaps Analysis</h2>
        <p className="text-gray-600 mt-2">Identifying opportunities for enhanced data collection and analysis</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-xl font-semibold mb-4 text-red-600">High Priority Gaps</h3>
          <ul className="space-y-3">
            <li className="flex items-start space-x-3">
              <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
              <span className="text-gray-700">Annual anxiety diagnosis trends</span>
            </li>
            <li className="flex items-start space-x-3">
              <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
              <span className="text-gray-700">Depression visit volumes by year</span>
            </li>
            <li className="flex items-start space-x-3">
              <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
              <span className="text-gray-700">Outcomes measurement data</span>
            </li>
            <li className="flex items-start space-x-3">
              <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
              <span className="text-gray-700">Sociodemographic breakdowns</span>
            </li>
          </ul>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-xl font-semibold mb-4 text-yellow-600">Medium Priority Gaps</h3>
          <ul className="space-y-3">
            <li className="flex items-start space-x-3">
              <span className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></span>
              <span className="text-gray-700">Payor mix for non-ADHD conditions</span>
            </li>
            <li className="flex items-start space-x-3">
              <span className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></span>
              <span className="text-gray-700">Telehealth by diagnosis type</span>
            </li>
            <li className="flex items-start space-x-3">
              <span className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></span>
              <span className="text-gray-700">Treatment completion rates</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-8 p-4 border-l-4 border-yellow-200 bg-yellow-50">
        <strong>Data Strategy:</strong> Addressing these gaps will enhance program evaluation and enable more targeted interventions.
      </div>
    </div>
  );
};

export default DataGapsSection;
